import React, { useCallback, useEffect } from "react";
import {get, set} from 'lodash'
import useApiHouse from "../api/useApiHouse";
import { updateFormPayload } from "../api/apiPayloads";
import { useSelector } from "react-redux";
import { dateToEpoch } from "../util/index";

const useUpdateForm = () => {
    const [updateFormApi, {data, error, isLoading}] = useApiHouse();
    const {currentJob: {reconShipmentId}} = useSelector((state) => state.currentJob)
    const updateForm = useCallback(({target: {name, value}}, event, otherFields) => {
        const reconId = reconShipmentId;
        let updatedFields = {}
        if(event === "PAYMENT_UPDATE"){
            updatedFields.parentReconShipment = reconId;
        }
        else{
            updatedFields.reconShipmentId = reconId;
        }
        updatedFields = {...updatedFields, ...otherFields}
        set(updatedFields, name, value);
        updateFormApi(updateFormPayload(updatedFields, event))
    }, [])

    useEffect(() => {
        if(!isLoading && data){
            console.log("data:", data)
        }
        if(error){
            console.log("errors:", error)
        }
    }, [isLoading, data, error])
    return { updateForm }
}
 
export default useUpdateForm;